import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const subsApi = {
  list: () => api.get("/subscriptions").then((r) => r.data),
  create: (payload) => api.post("/subscriptions", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/subscriptions/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/subscriptions/${id}`).then((r) => r.data),
  seedDemo: () => api.post("/subscriptions/seed-demo").then((r) => r.data),
  removeAllDemo: () => api.delete("/subscriptions/demo/all").then((r) => r.data),
};

export const settingsApi = {
  get: () => api.get("/settings").then((r) => r.data),
  update: (payload) => api.put("/settings", payload).then((r) => r.data),
};
